

//meアプリリンク用　OSチェック
window.addEventListener("load", () => {
  const AppLink = document.querySelector(".--applink");
  const uA = navigator.userAgent;

  if (AppLink) {

    if (window.outerWidth < 1024) {
      if (uA.indexOf("iPhone") > 0 || uA.indexOf("iPad") > 0) {
        AppLink.setAttribute(
          "href",
          "https://apps.apple.com/jp/app/%E8%A5%BF%E6%97%A5%E6%9C%AC%E6%96%B0%E8%81%9Eme-%E7%A6%8F%E5%B2%A1%E3%81%AE%E3%83%8B%E3%83%A5%E3%83%BC%E3%82%B9-%E3%83%A9%E3%82%A4%E3%83%96%E3%82%AB%E3%83%A1%E3%83%A9-%E7%94%9F%E6%B4%BB%E6%83%85%E5%A0%B1%E3%82%A2%E3%83%97%E3%83%AA/id1488721072"
        );
      } else {
        AppLink.setAttribute(
          "href",
          "https://play.google.com/store/apps/details?id=jp.co.nishinippon.smartphone"
        );
      }
    } else {
      if (uA.indexOf("Mac OS X") > 0) {
        AppLink.setAttribute(
          "href",
          "https://apps.apple.com/jp/app/%E8%A5%BF%E6%97%A5%E6%9C%AC%E6%96%B0%E8%81%9Eme-%E7%A6%8F%E5%B2%A1%E3%81%AE%E3%83%8B%E3%83%A5%E3%83%BC%E3%82%B9-%E3%83%A9%E3%82%A4%E3%83%96%E3%82%AB%E3%83%A1%E3%83%A9-%E7%94%9F%E6%B4%BB%E6%83%85%E5%A0%B1%E3%82%A2%E3%83%97%E3%83%AA/id1488721072"
        );
      } else {
        AppLink.setAttribute(
          "href",
          "https://play.google.com/store/apps/details?id=jp.co.nishinippon.smartphone&hl=ja&gl=US"
        );
      }
    }

  }
});

//TOP HEROの位置調整

const topHeroTitle = document.querySelector('.top-hero-title__wrapper');



window.addEventListener('load', () => {
  if (topHeroTitle) {

    const ua = window.navigator.userAgent;

    if (ua.indexOf('android') < 0) {
      topHeroTitle.classList.add('--android-position')
    }
  }
})